import { Grid } from "@mui/material";
import TentativiChiamata from "../UI/Card/TentativiChiamata";
import DurataMediaEffettuate from "../UI/Card/DurataMediaEffettuate";
import DurataMediaRicevute from "../UI/Card/DurataMediaRicevute";
import DurataMediaChiamate from "../UI/Card/DurataMediaChiamate";
import RiepilogoTentativiMediaChiamate from "../UI/Card/RiepilogoTentativiMediaChiamate";
import "./CallDataContainer.css";


function CallDataContainer({ dataPicker, refresh, deviceFilter }) {

  return (
    <>
        <Grid container item spacing={2}>
            <DurataMediaChiamate refresh={refresh} dataPicker={dataPicker} deviceFilter={deviceFilter}></DurataMediaChiamate>
            <DurataMediaEffettuate refresh={refresh} dataPicker={dataPicker} deviceFilter={deviceFilter}></DurataMediaEffettuate>
            <DurataMediaRicevute refresh={refresh} dataPicker={dataPicker} deviceFilter={deviceFilter}></DurataMediaRicevute>
            <TentativiChiamata refresh={refresh} dataPicker={dataPicker} deviceFilter={deviceFilter}></TentativiChiamata>
            <RiepilogoTentativiMediaChiamate refresh={refresh} dataPicker={dataPicker} deviceFilter={deviceFilter}></RiepilogoTentativiMediaChiamate>
        </Grid>
    </>
  )
}

export default CallDataContainer;
